import { Link } from "react-router-dom";
import { LegalFooterLinks } from "./LegalDocumentModal";
import SocialLinks from "./SocialLinks";
import "../styles/components.css";

const SUPPORT_EMAIL = "beachbumpass@gmail.com";

const FOOTER_LINKS = [
    {
        to: "/discover",
        label: "Discover",
        note: "Activities & Pass Perks",
    },
    {
        to: "/passes",
        label: "Passes",
        note: "Build Your Beach Run",
    },
    {
        to: "/how-it-works",
        label: "How It Works",
        note: "The Quick Rundown",
    },
    {
        to: "/vendor",
        label: "Vendor Portal",
        note: "Partner Check-In",
    },
];

function MailIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
                d="M4 6.5h16v11H4v-11Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
            />
            <path
                d="m5 7.5 7 5.25 7-5.25"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer footer--reference footer--clean-v2">
            <div className="footer-beach-trim" aria-hidden="true">
                <div className="footer-beach-shells">
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
            </div>

            <div className="footer-inner footer-reference-inner">
                <div className="footer-reference-top">
                    <section className="footer-left-column" aria-label="Beach Bum Pass footer information">
                        <Link to="/" className="footer-brand-lockup" aria-label="Beach Bum Pass home">
                            <img
                                src="/assets/Graphics/Logo.png"
                                alt=""
                                className="footer-logo"
                                aria-hidden="true"
                            />

                            <div className="footer-brand-copy">
                                <strong>Beach Bum Pass</strong>
                                <span>Live Like a Local on the Emerald Coast.</span>
                            </div>
                        </Link>

                        <div className="footer-contact-row" aria-label="Beach Bum Pass contact information">
                            <MailIcon />
                            <span>Have a question? Email us at</span>
                            <strong>{SUPPORT_EMAIL}</strong>
                        </div>

                        <div className="footer-social-row" aria-label="Beach Bum Pass social links">
                            <SocialLinks variant="footer" />
                        </div>
                    </section>

                    <nav className="footer-right-column" aria-label="Footer navigation">
                        <div className="footer-link-panel">
                            <div className="footer-link-group footer-link-group--main">
                                <p className="footer-link-eyebrow">Explore</p>
                                <div className="footer-main-links">
                                    {FOOTER_LINKS.map((item) => (
                                        <Link key={item.to} to={item.to} className="footer-main-link-card">
                                            <span>{item.label}</span>
                                            <small>{item.note}</small>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="footer-nav-rule" aria-hidden="true" />

                            <div className="footer-link-group footer-link-group--legal">
                                <p className="footer-link-eyebrow">Need to Know</p>
                                <div className="footer-legal-links">
                                    <LegalFooterLinks />
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

                <div className="footer-bottom-rule" aria-hidden="true" />

                <div className="footer-meta">
                    <p className="footer-copy">
                        &copy; {year} Beach Bum Pass. All rights reserved.
                    </p>

                    <p className="footer-seller">
                        Florida Beach Bum Ventures, LLC dba Beach Bum Pass. Registered with the State of Florida as a Seller of Travel. Registration No. ST46219.
                    </p>
                </div>
            </div>
        </footer>
    );
}
